import { jwtDecode } from 'jwt-decode'
import { getDomainNames, isBusinessURL } from './routes'

declare module 'jwt-decode' {
  export interface JwtPayload {
    type: string
    active_business_id: number
  }
}
// Get environment name dynamically
export const getEnvironmentName = () => {
  const hostname = window.location.hostname

  // Handle localhost for local development
  if (hostname === 'localhost') {
    return 'react-local'
  }
  // Extract subdomain (everything before the first dot)
  const subdomain = hostname.split('.')[0]
  // Return the subdomain if it exists, otherwise default to 'prod'
  return subdomain || 'prod'
}
export const getAccessTokenFromCookie = () => {
  let envName
  if (isBusinessURL()) {
    const domainNames = getDomainNames()
    envName = domainNames[1]
  }
  else {
    envName = getEnvironmentName()
  }
  const cname = `token_${envName}=`
  const cookieDecoded = decodeURIComponent(document.cookie)
  const cookieParts = cookieDecoded.split(';')
  for (let i = 0; i < cookieParts.length; i++) {
    let c = cookieParts[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(cname) == 0) {
      return c.substring(cname.length, c.length)
    }
  }
  return ''
}

export const isAuthenticated = () => {
  return getAccessTokenFromCookie() ? true : false
}
export const setTokenInCookie = (authRes: string) => {
  const expiry = new Date(Date.now() + 86400000) // 1 day in milliseconds
   let envName
   if (isBusinessURL()) {
     const domainNames = getDomainNames()
     envName = domainNames[1]
   } else {
     envName = getEnvironmentName()
   }
  document.cookie = `token_${envName}=${authRes};domain=${
    process.env.REACT_APP_DOMAIN
  };expires=${expiry.toUTCString()};path=/`
}

export const clearTokenFromCookie = () => {
  document.cookie = `token_${getEnvironmentName()}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=${
    process.env.REACT_APP_DOMAIN
  };path=/;`
}

export const getUserTypeFromToken = () => {
  const token = getAccessTokenFromCookie()
  if (token) {
    return decodeTokenType(token)
  } else {
    return ''
  }
}

export const decodeTokenDetails = () => {
  const token = getAccessTokenFromCookie()
  if (token) {
    try {
      const decodedTokenDetails = jwtDecode(token)
      return decodedTokenDetails
    } catch (error) {
      // Invalid token specified
      return null
    }
  } else {
    // No token found
    return null
  }
}

export const decodeTokenType = (token: string) => {
  try {
    const decodedTokenDetails = jwtDecode(token)
    const { type } = decodedTokenDetails
    return type
  } catch (error) {
    return ''
  }
}
